import React from 'react';
import {
  MenuItem,
  Checkbox,
  FormControlLabel,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  LinearProgress,
  Select,
  Stack,
  TextField,
  Button,
} from '@mui/material';
import { PROVIDER_ID, USER_TYPE } from '../../constants';

const SoDialog = ({ open, state, handlers, offerList, isOffersLoading, isOffersFetching, isOfferDetailsLoading }) => {
  const { formData, isEditing, isCreating, isUpdating } = state;
  const { handleClose, handleSave, handleField, handleSwitch, setFormData } = handlers;
  const isSavingDisabled = isCreating || isUpdating || isOfferDetailsLoading;

  const nameFields = [
    { label: 'Name (AZ)', key: 'nameAz' },
    { label: 'Name (EN)', key: 'nameEng' },
    { label: 'Name (RU)', key: 'nameRu' },
  ];

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditing ? 'Edit Offer' : 'New Offer'}</DialogTitle>
      {isOfferDetailsLoading && <LinearProgress />}
      <DialogContent>
        <Stack spacing={2} mt={2}>
          <FormControl fullWidth>
            <InputLabel id="primaryOfferIds-label">Primary Offers</InputLabel>
            <Select
              multiple
              labelId="primaryOfferIds-label"
              label="Primary Offers"
              value={formData.primaryOfferIds}
              onChange={(e) => setFormData((prev) => ({ ...prev, primaryOfferIds: e.target.value }))}
              disabled={isOffersLoading || isOffersFetching || isOfferDetailsLoading}
              renderValue={(selected) =>
                offerList
                  .filter((item) => selected.includes(item.value))
                  .map((item) => item.label)
                  .join(', ')
              }
            >
              {offerList?.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  <Checkbox checked={formData.primaryOfferIds.includes(item.value)} />
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Title"
            value={formData.title}
            onChange={handleField('title')}
            fullWidth
            autoFocus
            disabled={isOfferDetailsLoading}
          />

          <Stack direction="row" spacing={2}>
            {nameFields.map((item) => (
              <TextField
                key={item.key}
                label={item.label}
                value={formData[item.key]}
                onChange={handleField(item.key)}
                fullWidth
                disabled={isOfferDetailsLoading}
              />
            ))}
          </Stack>

          <Stack direction="row" spacing={2}>
            <TextField
              label="Price"
              type="number"
              value={formData.price}
              onChange={handleField('price')}
              fullWidth
              disabled={isOfferDetailsLoading}
            />
            <TextField
              label="Offer ID"
              value={formData.offerId}
              onChange={handleField('offerId')}
              fullWidth
              disabled={!!isEditing || isOfferDetailsLoading}
            />
            <FormControl fullWidth>
              <InputLabel id="provider-label">Provider</InputLabel>
              <Select
                labelId="provider-label"
                label="Provider"
                value={formData.providerId}
                onChange={handleField('providerId')}
                disabled={isOfferDetailsLoading}
              >
                {PROVIDER_ID.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={3}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.esimFlag}
                  onChange={handleSwitch('esimFlag')}
                  disabled={isOfferDetailsLoading}
                />
              }
              label="eSIM"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.dataSimFlag}
                  onChange={handleSwitch('dataSimFlag')}
                  disabled={isOfferDetailsLoading}
                />
              }
              label="Data SIM"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.asanImzaFlag}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      asanImzaFlag: e.target.checked,
                      userType: e.target.checked ? prev.userType : '',
                    }))
                  }
                  disabled={isOfferDetailsLoading}
                />
              }
              label="Asan İmza"
            />
          </Stack>

          {formData.asanImzaFlag && (
            <FormControl fullWidth>
              <InputLabel id="userType-label">User Type</InputLabel>
              <Select
                labelId="userType-label"
                label="User Type"
                value={formData.userType}
                onChange={handleField('userType')}
                disabled={isOfferDetailsLoading}
              >
                {USER_TYPE.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={isSavingDisabled}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SoDialog;
